export default function Sass_Selector() {
  return (
    <div>
      <h1>Sass Selector</h1>
    </div>
  );
}
